<template>
  <div class="nx-flex-align-center user">
    <div class="user__header nx-relative">
      <nx-image :src="userImg" :width="width" :height="height" :border-radius="borderRadius" round />
      <template v-if="vip">
        <nxImage v-if="vip===1||vip===2||vip===3" :is-oss="false" class="user__vip" :src="require(`@/assets/images/user/vip_${vip}.png`)" width="14px" height="14px" />
      </template>
    </div>
    <div class="user__title nx-margin-l-small">
      <div>{{ userTitle }}</div>
      <nxImage v-if="vip===1" class="user__official" :src="require('@/assets/images/user/official.png')" width="58px" height="15px" />
    </div>
    <div v-if="creatTime" class="user__time">{{ $utils.formatDate((creatTime||''),'YYYY-MM-DD')||'' }}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'NxUser',
  components: {},
  props: {
    width: {
      type: Number,
      default: 44,
    },
    height: {
      type: Number,
      default: 44,
    },
    borderRadius: {
      type: String,
      default: '32rpx',
    },
    userImg: {
      type: String,
      default: '',
    },
    userTitle: {
      type: String,
      default: '用户',
    },
    creatTime: {
      type: [String, Number],
      default: '',
    },
    vip: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped lang="scss">
.user{
  // color: #fff;
  &__time{
    margin-left: 20px;
  }
  &__vip{
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &__official{
    margin-top: 5px;
  }
  &__title,&__time{
  font-size: 14px;
  }
}
</style>
